<template>
  <footer>
    <div class="container relative !max-w-none overflow-hidden">
      <img v-if="currentPath === '/'" src="@/assets/images/Sans titre-4.png" alt="main" class="w-[190%] mt-[7%] -ml-[2%] relative z-50 mb-[-20%] rotate-[-5deg]" />
      <div class="relative z-30"><img
        v-if="currentPath === '/'"
        src="@/assets/images/bottom-solo.png"
        alt="main"
        class="w-full m-auto max-w-[1200px] relative z-30"
      />
      <img
        v-else
        src="@/assets/images/bottom-solo.png"
        alt="main"
        class="w-full  max-w-[1200px]  m-auto"
      /></div>
      <div class="absolute  left-0 w-full text-white text-[2vw] sm:text-[80%] flex justify-center gap-[4%] items-center z-50 "
      :class="currentPath === '/' ? 'bottom-[4%] sm:bottom-[4%]' : 'bottom-[12.9%] sm:bottom-[15.9%]'">
        <div class=" pt-[4%]"><span class="block  text-white text-[2vw] sm:text-xs "> {{ $t("footer.slogan") }}</span> </div>
        <div class="w-[35%]"><img src="@/assets/images/logo.png"></div>
      </div>
      <!---<div
        class="absolute left-[3%] w-[80%] text-white text-[2vw] sm:text-[80%] z-40"
        :class="currentPath === '/' ? 'bottom-[5.4%] sm:bottom-[5.6%]' : 'bottom-[19.5%] sm:bottom-[19.9%]'"
      >
        {{ $t("footer.slogan") }}
      </div> -->
    </div>

    <div class="container !max-w-none bg-white p-4">
      <ul
        class="flex justify-center flex-wrap items-center gap-4 desktop:text-[3xl] leading-3"
      >
        <li>
          <a v-if="currentLanguage =='fr'"
            :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/68552be91faa14bae3fa258a/reglement.pdf`"
            target="_blank"
            >{{ $t("footer.rules") }}</a
          >
          <a v-else
            :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/68552be91faa14bae3fa258a/reglement${currentLanguage}.pdf`"
            target="_blank"
            >{{ $t("footer.rules") }}</a
          >
        </li>
        <li>|</li>
        <li>
          <a  v-if="currentLanguage =='fr'"
            :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/68552be91faa14bae3fa258a/mentions.pdf`"
            target="_blank"
            >{{
            $t("footer.legalNotice")
          }}</a
          >
          <a v-else
            :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/68552be91faa14bae3fa258a/mentions${currentLanguage}.pdf`"
            target="_blank"
            >{{
            $t("footer.legalNotice")
          }}</a
          >
        </li>        
        <!--<li>
          <router-link to="/mentions">{{
            $t("footer.legalNotice")
          }}</router-link>
        </li>-->
        <li>|</li>
        <li>
          <a v-if="currentLanguage =='fr'"
            :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/68552be91faa14bae3fa258a/politique.pdf`"
            target="_blank"
            >{{ $t("footer.privacyPolicy") }}</a
          >
          <a v-else
            :href="`https://oxoformdocs.fra1.digitaloceanspaces.com/68552be91faa14bae3fa258a/politique${currentLanguage}.pdf`"
            target="_blank"
            >{{ $t("footer.privacyPolicy") }}</a
          >
        </li>
        <li>|</li>
        <li>
          <router-link to="/contact">{{ $t("footer.contactUs") }}</router-link>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
  computed: {
    currentPath() {
      return this.$route.path;
    },
    currentLocale() {
      return this.$i18n.locale;
    },
    currentLanguage() {
      const locales = {
        fr: '',
        en: '-en', 
        es: '-es'
      };
      return locales[this.$i18n.locale] || this.$i18n.locale;
    }
  },
  methods: {
    // Méthode pour changer la langue
    changeLanguage(locale) {
      this.$i18n.locale = locale;
    },
    // Méthode pour obtenir la langue courante
    getCurrentLanguage() {
      return this.$i18n.locale;
    }
  }
};
</script>
